module.exports = __webpack_public_path__ + "img/aboutTitle@2x.fba4d885.png";